var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"footer",attrs:{"app":""}},[_c('p',{staticClass:"ma-0 text-center"},[_c('small',[_vm._v(_vm._s(_vm.$t('footer.message.copyright')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }